// extracted by mini-css-extract-plugin
module.exports = {"page-settings":"LwYeV","pageSettings":"LwYeV","no-padding":"_2PpT9","noPadding":"_2PpT9"};